'use client';

import { Button } from '@doist/marketist';
import GetStartedButton from 'components/Get-Started-Button/Get-Started-Button';
import { useCTAsData } from 'services/hooks/use-ctas-data';
export function StartForFreeButton() {
  const ctaData = useCTAsData('home-page-intro');
  return <>
            {ctaData ? <Button size="large" variant={ctaData.variant} href={ctaData.href} {...ctaData.dataAttributes}>
                    {ctaData.text}
                </Button> : <GetStartedButton size="xl" />}
        </>;
}